import HorsesTable from './HorsesTable';

export default HorsesTable;
